import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/userStore';

/**
 * useSubscription — small wrapper around userStore getters to read the
 * current company's plan from any component.
 *
 *   const { isCohort, isLaunchpad, canAccessMonitor } = useSubscription();
 *
 *   <SidebarItem v-if="canAccessMonitor" to="/monitor" />
 *
 * The source of truth is `company.subscriptionType` returned by
 * /api/auth/login and /api/transactions/onProcessPayment.
 *
 * Plan values (escala ascendente):
 *   "baseline"  → solo las evaluaciones ASIGNADAS y sus reportes
 *   "launchpad" → restringido (sin cambios respecto de antes)
 *   "cohort"    → acceso completo
 *   null        → baseline (el piso)
 *
 * ⚠️ `isLaunchpad` significa "no llega a cohort", no "está en launchpad": con
 * baseline abajo cubre dos planes. Para el escalón exacto, usar `tier`.
 */
export const useSubscription = () => {
  const userStore = useUserStore();

  const {
    subscriptionType,
    tier,
    isCohort,
    isBaseline,
    isLaunchpad,
    canAccessMonitor,
    canAccessNetwork,
    canAccessFullActionPlan,
    canAccessActionPlan,
    subscription,
    subscriptionStatus,
    subscriptionDaysLeft,
    subscriptionCurrentPeriodEnd,
    subscriptionCancelAtPeriodEnd,
    isSubscriptionInGrace,
    isSubscriptionLapsed,
  } = storeToRefs(userStore);

  return {
    subscriptionType,
    tier,
    isCohort,
    isBaseline,
    isLaunchpad,
    canAccessMonitor,
    canAccessNetwork,
    canAccessFullActionPlan,
    canAccessActionPlan,
    subscription,
    subscriptionStatus,
    subscriptionDaysLeft,
    subscriptionCurrentPeriodEnd,
    subscriptionCancelAtPeriodEnd,
    isSubscriptionInGrace,
    isSubscriptionLapsed,
  };
};
